import { ReactComponent as ColumnIcon } from './column.svg';

export default ColumnIcon;
